import React from "react";
var __jsx = React.createElement;
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import PreCheckoutOptionsShimmer from "@/pages/checkout/pre-checkout/PreCheckoutOptionsShimmer";
import PurchaseMethods from "@/pages/checkout/pre-checkout/PurchaseMethods/PurchaseMethods";
var PreCheckoutFormRenderer = function PreCheckoutFormRenderer() {
  var checkoutOrder = useCheckoutOrder().state.checkoutOrder;
  // If checkoutOrder is not yet available, show a loading shimmer
  if (!checkoutOrder) {
    return /*#__PURE__*/React.createElement(PreCheckoutOptionsShimmer, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PurchaseMethods, null));
};
export default PreCheckoutFormRenderer;